import React, { memo } from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Prompt } from './Prompt';
import { PromptType, PromptsListProps } from '../types';

const PromptsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(2),
  justifyContent: 'center',
  maxWidth: '800px',
  width: '100%',
}));

export const PromptsList: React.FC<PromptsListProps> = memo(({
  prompts,
  onClick,
  disabled = false,
}) => {
  return (
    <PromptsContainer>
      {prompts.map((prompt, index) => {
        const key = typeof prompt === 'string' 
          ? `prompt-${index}` 
          : prompt.id || `prompt-${index}`;
        
        return (
          <Prompt
            key={key}
            prompt={prompt}
            onClick ={onClick}
            disabled={disabled}
          />
        );
      })}
    </PromptsContainer>
  );
});

PromptsList.displayName = 'PromptsList';

